export default __webpack_public_path__ + "static/media/Abhishek_Kamble_Resume.30aa66b0.pdf";